import { ApiError } from '../api/client.js';

const DEFAULT_BY_CODE = {
  validation_failed: 'Please check the fields above.',
  invalid_credentials: 'Invalid email or password.',
  email_not_verified: 'Please verify your email before logging in.',
  subscription_expired: 'Your subscription has expired.',
  email_exists: 'If this email is available, a verification code has been sent.',
  rate_limited: 'Too many requests. Please wait a moment and try again.',
  invalid_code: 'That code didn\u2019t match. Try again or request a new one.',
  expired: 'Your code has expired. Request a new one.',
  too_many_attempts: 'Too many attempts. Please request a new code.',
  invalid_or_expired: 'This reset link is invalid or expired.',
  csrf_invalid: 'Your session expired. Please reload and try again.',
  auth_required: 'Please log in to continue.',
  http_error: 'Something went wrong. Please try again.',
};

export function FormError({ error }) {
  if (!error) return null;
  let message = null;
  if (typeof error === 'string') {
    message = error;
  } else if (error instanceof ApiError) {
    const hasServerMessage =
      typeof error.message === 'string' && error.message && error.message !== error.code;
    message =
      DEFAULT_BY_CODE[error.code] ||
      (hasServerMessage ? error.message : null) ||
      'Something went wrong.';
  } else if (error && typeof error.message === 'string') {
    message = error.message;
  } else {
    message = 'Something went wrong.';
  }
  return (
    <div className="form-global-error" role="alert">
      {message}
    </div>
  );
}

export function FormSuccess({ message }) {
  if (!message) return null;
  return (
    <div className="form-global-success" role="status">
      {message}
    </div>
  );
}
